export default "__VITE_ASSET__DvA_gFuV__"